import { ResidentialPropertyListingConnectionEdge } from '@unreserved-frontend-v2/api/generated/graphql/types'
import { LngLatBoundsLike } from 'maplibre-gl'
import { extendBounds } from '../components/map/utils-lite'

/**
 * Calculates the bounds for the passed-in listings.
 * @param listings The listings to get the bounds for.
 * @returns A bounds if there were listings. undefined otherwise.
 */
export const getBoundsForListings = (edges: unknown): LngLatBoundsLike | undefined => {
  let bounds: LngLatBoundsLike | undefined = undefined
  const listings = edges as ResidentialPropertyListingConnectionEdge[]
  listings.forEach((l) => {
    const { latitude, longitude } = l?.node?.property.address || {}
    if (latitude && longitude) {
      bounds = extendBounds(bounds, longitude, latitude)
    }
  })

  return bounds
}
